document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-slider-button]');
  if (!button) return;

  const slider = button.closest('[data-product-slider]');
  const track = slider?.querySelector('[data-slider-track]');
  if (!track) return;

  const direction = button.dataset.sliderButton === 'next' ? 1 : -1;
  const card = track.querySelector('.product-card');
  const distance = card ? card.getBoundingClientRect().width + 24 : 324;

  track.scrollBy({
    left: direction * distance,
    behavior: 'smooth'
  });
});
